import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 0AA8EAC5-6700-47B6-A38B-0E58CFA0CFE7
 * name application-settings
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-settings.svg
 * tags
 * - Settings 
 */
export const ApplicationSettingsIcon = createSvgIcon(<><path d="M21 0H3C1.9 0 1 .9 1 2V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V2C23 .9 22.1 0 21 0M21 5H3V2H21V5M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15V22" /></>, 'ApplicationSettingsIcon');
export default ApplicationSettingsIcon